import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'
import Api from '../../../../_helpers/Api'
import Dropdown from '../../../partials/Dropdown'
import { fromInfo, trans } from '../../../../_providers/Translation'
import Help from '../../../partials/Help'
import { Tab, Tabs } from '@mui/material'
import DateRange from '@/components/partials/DateRange'

function Filter(props) {

    const employeesDropdownRef = useRef(null)
    const categoryDropdownRef = useRef(null)

    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const [state, setState] = useState({
        employees: [],
        selectedEmployees: {},
        groups: []
    })

    useEffect(() => {
        // Api.get('partners/employees/technicians')
        //     .then(res => {
        //         setState(prev => ({
        //             ...prev,
        //             employees: res.data
        //         }))
        //     })

        Api.get('partners/groups/all')
            .then(res => {
                setState(prev => ({
                    ...prev,
                    groups: res.data
                }))
            })
    }, [])

    useEffect(() => {
        setState(prev => ({
            ...prev,
            selectedEmployees: Array.isArray(props.data.employees) ? props.data.employees : []
        }))
    }, [props.data.employees])

    const handleSearch = e => {
        let name = e.target.name
        let val = e.target.value

        props.handleSearch(name, val)
    }

    const handleCategory = data => {

        let val = data.id || ''

        if (data.id || data.name == '') {
            props.handleSearch('category_id', val)
        }

    }



    const handleCheckEmployee = e => {
        const selected = e.map(d => d.id)
        setState(prev => ({
            ...prev,
            selectedEmployees: selected
        }))
        props.handleEmployees(selected)
    }

    const handleGroup = e => {
        let id = e.target.value

        props.handleGroup(id)
    }

    const handleSelectMobileFilter = e => {
        let selectedValue = e.target.value
        let fields = [...document.querySelectorAll('.filter-standard .col')]
        fields.map(field => {
            if (field.getAttribute('data-id') == selectedValue) field.style.display = 'flex'
            else if (field.getAttribute('data-id')) field.style.display = 'none'
        })
    }

    const handleNearbyTech = () => {
        // Your existing logic for handling nearby technician
    }

    const handleClearFilters = () => {
        props.handleSearch('start', '')
        props.handleSearch('end', '')
        employeesDropdownRef.current.removeAll()
        handleCheckEmployee([])
        props.handleSearch('search', '')
        props.handleGroup(null)
        props.handleSearch('category_id', '')
        categoryDropdownRef.current.reset()
    }


    return (
        <>

            <div className="filter-standard schedule-filter" style={{ paddingBottom: 0 }}>
                <div
                    className='col heading-holder'
                >
                    <b>
                        Резервации
                    </b>
                </div>
                <div className="col" data-id="5">
                    <input
                        name="search"
                        type="search"
                        value={props.data.search}
                        onChange={handleSearch}
                        placeholder={trans('labels.search')}
                    />
                </div>
                {/* <div className='col'>
                    <DateRange
                        startDate={props.data.start}
                        endDate={props.data.end}
                        onStartDateChange={(date) => {
                            props.handleSearch('start', date)
                        }} onEndDateChange={(date) => {
                            props.handleSearch('end', date)
                        }}
                    />
                </div> */}
                <div className="col" data-id="4">
                    <Dropdown
                        ref={categoryDropdownRef}
                        inputIdValue={Number(props.data.category_id)}
                        url="appliances/categories/all"
                        renderText={data => {
                            return data.name
                        }}
                        onChange={data => {
                            handleCategory(data)
                        }}
                        inputPlaceholder={trans('labels.category')}
                    />
                </div>
                <div className='col'>
                    <select
                        name="group_id"
                        value={props.data.group_id}
                        onChange={handleGroup}
                    >
                        <option value="">{trans('labels.technicianGroup')}</option>
                        {state.groups.map(g =>
                            <option key={'g-' + g.id} value={g.id}>
                                {g.name}
                            </option>
                        )}
                    </select>
                </div>
                <div className='col'>
                    <div className="filter-standard schedule-filter">
                        <div className="col" style={{ paddingTop: '3px' }}>
                            <div className="row no-margin">
                                <Dropdown
                                    url="partners/employees/technicians"
                                    renderText={data => {
                                        return `${data.name} ${data.lastname}`
                                    }}
                                    onChange={data => {
                                        handleCheckEmployee(data)
                                    }}
                                    inputIdName="id"
                                    selectedIds={state.selectedEmployees}
                                    multiple
                                    ref={employeesDropdownRef}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col'>
                    <button type='button' className='button-clear-filter' onClick={handleClearFilters}>
                        Изчистване
                    </button>
                </div>
            </div>
        </>
    )
}

export default Filter